<template>
  <div class="authority-card" title="Zur Behörden-Detailseite">
    <router-link :to="`/behoerden/${authority.id}`">
      <Card padding="0px">
        <div class="authority-card__content">
          <div class="authority-card__content__top">
            <h3>{{ authority.name }}</h3>
            <p>{{ authority.services.length }} Online-Leistungen</p>
          </div>
          <img src="../../assets/images/logo.svg" alt="">
        </div>
      </Card>
    </router-link>
  </div>
</template>

<script>
import Card from '../Card/Card';
import Icon from '../Icon/Icon';

export default {
  name: 'AuthorityCard',
  components: {
    Card,
    Icon,
  },
  props: {
    authority: {
      type: Object,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./AuthorityCard.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AuthorityCard/AuthorityCard.vue